import { render } from "./professional-index.vue?vue&type=template&id=1ce84126"
import script from "./professional-index.vue?vue&type=script&lang=js"
export * from "./professional-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__